var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import styled from '@xstyled/styled-components';
import { useClickOutside } from '../../../Modal/hooks/useClickOutside';
import Button from '../../../../Elements/Button/Button';
import DropdownMenu from '../../../../Elements/DropdownMenu';
var ButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: fit-content;\n"], ["\n  position: relative;\n  width: fit-content;\n"])));
var StyledDropdownMenu = styled(DropdownMenu)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  bottom: ", ";\n  right: 0;\n  width: max-content;\n  z-index: 2;\n"], ["\n  position: absolute;\n  top: ", ";\n  bottom: ", ";\n  right: 0;\n  width: max-content;\n  z-index: 2;\n"])), function (_a) {
    var dropdownPosition = _a.dropdownPosition;
    return (!dropdownPosition || dropdownPosition === 'bottom' ? 'calc(100% + 8px)' : 'auto');
}, function (_a) {
    var dropdownPosition = _a.dropdownPosition;
    return (dropdownPosition === 'top' ? 'calc(100% + 13px)' : 'auto');
});
var ButtonMore = function (_a) {
    var items = _a.items, disabled = _a.disabled, dropdownPosition = _a.dropdownPosition;
    var _b = useState(false), actionsVisible = _b[0], setActionsVisible = _b[1];
    var onClose = useCallback(function () {
        setActionsVisible(false);
    }, []);
    var ref = useClickOutside({ onClose: onClose });
    var handleClick = useCallback(function () {
        setActionsVisible(!actionsVisible);
    }, [actionsVisible]);
    return (_jsxs(ButtonWrapper, { ref: ref, children: [_jsx(Button, { onClick: handleClick, icon: "ellipsisVertical", appearance: "secondary", variant: "icon", type: "button", "data-cy": "gridActionBtn", disabled: disabled }), _jsx(StyledDropdownMenu, { showMenu: actionsVisible, items: items, dropdownPosition: dropdownPosition })] }));
};
export default ButtonMore;
var templateObject_1, templateObject_2;
